import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, Title4 } from "@components/Typography";
import { useCancelContribution, useErrorBanner, useModal, useSuccessBanner } from "@hooks";
import { i18n, Translations } from "@i18n";
import { EditOneTimeContributionModalProps } from "@routes/TransfersRoute/TransactionList/EditOneTimeContributionModal/types";

export const CancelContributionModal = ({ item }: EditOneTimeContributionModalProps) => {
  const { dismiss } = useModal();
  const { showErrorBanner } = useErrorBanner();
  const { showSuccessBanner } = useSuccessBanner();

  const [cancelContribution, { loading }] = useCancelContribution();

  const handleSubmit = async () => {
    if (!item.id) return showErrorBanner();

    try {
      await cancelContribution({
        variables: {
          transactionId: item.id,
        },
      });

      dismiss();
      showSuccessBanner(i18n.t(Translations.CancelContributionSuccessMessage));
    } catch (e: any) {
      const message = e.graphQLErrors?.[0]?.message;
      showErrorBanner(message);
    }

    dismiss();
  };

  const props: OverlayProps = {
    cta: {
      primary: {
        title: i18n.t(Translations.CancelContributionModalPrimaryCTA),
        onClick: handleSubmit,
        loading,
      },
      secondary: {
        title: i18n.t(Translations.CancelContributionModalSecondaryCTA),
        onClick: dismiss,
      },
    },
  };

  return (
    <Overlay {...props}>
      <Title4>{i18n.t(Translations.CancelContributionModalTitle)}</Title4>
      <Spacing size={SpacingSizes.M} />
      <Body>{i18n.t(Translations.CancelContributionModalSubtitle)}</Body>
      <Spacing size={SpacingSizes.XL} />
    </Overlay>
  );
};
